import React from 'react';
import { Formik } from 'formik';
import { ContactSearchDto } from '@app/api2/api';
import { Form as SForm, Divider } from 'semantic-ui-react';
import { SEARCH_TYPES_NAMES } from '../../types';
import { ContactSearchSchema } from './ContactForm.Schema';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import { FormWithButtons } from './FormWithButtons';
import { ChangeObserver } from '@app/components/React/Labs/ChangeObserver';

interface Props {
  currentParams: ContactSearchDto;
  setCurrentParams: (p: ContactSearchDto) => void;
  onChange?: (params: ContactSearchDto) => void;
}

export default function ContactForm({ currentParams, setCurrentParams, onChange }: Props) {
  const discriminator = SEARCH_TYPES_NAMES.ContactSearchDto;

  const initialValues: ContactSearchDto = {
    discriminator,
    operator: currentParams.operator,
    phoneNumber: currentParams.phoneNumber || '',
    emailAddress: currentParams.emailAddress || '',
    addressLine1: currentParams.addressLine1 || '',
    city: currentParams.city || '',
    state: currentParams.state,
    postalCode: currentParams.postalCode,
    country: currentParams.country,
  };

  const handleSubmit = (values: ContactSearchDto) => {
    setCurrentParams({ ...values, discriminator });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ContactSearchSchema}
      onSubmit={handleSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
    >
      {({ handleSubmit, values }) => (
        <>
          <ChangeObserver value={values} onChange={onChange} />
          <FormWithButtons handleSubmit={handleSubmit}>
            <SForm.Group widths="equal">
              <SemanticFormikInput
                name="phoneNumber"
                label="Phone Number"
                placeholder="Enter phone number"
              />
              <SemanticFormikInput
                name="emailAddress"
                label="Email Address"
                placeholder="Enter email address"
                type="email"
              />
            </SForm.Group>
            <Divider horizontal>OR Address</Divider>
            <SForm.Group widths="equal">
              <SemanticFormikInput
                name="addressLine1"
                label="Street Address"
                placeholder="Enter street address"
              />
              <SemanticFormikInput
                name="city"
                label="City"
                placeholder="Enter city"
              />
            </SForm.Group>
          </FormWithButtons>
        </>
      )}
    </Formik>
  );
}
